import { render, staticRenderFns } from "./hotPanelMulti.vue?vue&type=template&id=68b2f5c9&scoped=true"
import script from "./hotPanelMulti.vue?vue&type=script&lang=js"
export * from "./hotPanelMulti.vue?vue&type=script&lang=js"
import style0 from "./hotPanelMulti.vue?vue&type=style&index=0&id=68b2f5c9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b2f5c9",
  null
  
)

export default component.exports